<template>
  <div class="dialogDyn" ref="date">
    <el-table ref="naisData" tooltip-effect="dark" border highlight-current-row  :data="tableData.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table">
      <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
      </el-table-column>
    </el-table>
    <!--分页器-->
    <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="tableData.length" @size-change="handleSizeChange" :page-sizes="[5, 20, 50, 100]" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import bus from './bus'


  export default {
    name: "dialogDyn",
    data() {
      return {
        /*通过key刷新表格*/
        table:1,
        /*分页器的参数*/
        pageInfo: {
          currentPage: 1,
          pageSize: 5,
        },
        /*表格的最大高度*/
        tableHeight:'',
        /*表格组件渲染数组*/
        tableTitle:[
          {label:"案例编号",width:"120",prop:"caseNumber",show:false},
          {label:"参与方编号",width:"120",prop:"participantNumber",show:true},
          {label:"距离碰撞时间",width:"120",prop:"t",show:true},
          {label:"轨迹坐标X(m)",width:"120",prop:"mbdefCogposX",show:true},
          {label:"轨迹坐标Y(m)",width:"120",prop:"mbdefCogposY",show:true},
          {label:"速度(km/h)",width:"120",prop:"vel",show:true},
          {label:"分速度X(m/s)",width:"120",prop:"mbdefVelX",show:true},
          {label:"分速度Y(m/s)",width:"120",prop:"mbdefVelY",show:false},
          {label:"加速度X(m/s^2)",width:"120",prop:"mbdefAccX",show:true},
          {label:"加速度Y(m/s^2)",width:"120",prop:"mbdefAccY",show:true},
          {label:"是否采取制动(0:否 1:是)",width:"200",prop:"brake",show:true},
          {label:"航向角",width:"120",prop:"heading",show:true},
          {label:"TTC",width:"120",prop:"ttc",show:true},
          {label:"另一参与方轨迹X",width:"140",prop:"otherCoordinateX",show:true},
          {label:"另一参与方轨迹Y",width:"140",prop:"otherCoordinateY",show:true},
          {label:"另一参与方速度",width:"120",prop:"otherSpeed",show:true},
          {label:"另一参与方分速度X",width:"160",prop:"otherSpeedPartX",show:true},
          {label:"另一参与方分速度Y",width:"160",prop:"otherSpeedPartY",show:true},
          {label:"另一参与方加速度X",width:"160",prop:"otherAccelerationX",show:true},
          {label:"另一参与方加速度Y",width:"160",prop:"otherAccelerationY",show:true},
          {label:"另一参与方航向角",width:"160",prop:"otherHeading",show:true}
        ],
        /*表格数据*/
        tableData: [],
      }
    },
    methods:{
      /* 分页大小切换*/
      handleSizeChange(val) {
        this.pageInfo.pageSize = val;
      },
      /*分页切换*/
      handleCurrentChange(val) {
        this.pageInfo.currentPage = val;
      },
      /*获取高度*/
      getHeight(){
        /*定义两个高度，初始高度和现在高度*/
        let nowH;
        /*延迟获取当前高度*/
        this.$nextTick(()=>{
          nowH = this.$refs.date.offsetHeight - 36;
        });
        let height = this.tableHeight;
        /*比对操作*/
        if(nowH !== height){
          this.tableHeight = nowH;
          this.table++;
        }
      }
    },
    mounted(){
      /*当真实DOM渲染完成后调用该钩子获取当前data元素的高度并保存*/
      /*在created调用会报bug因为页面初始化时vue生命周期中先虚拟DOM，此时真实的DOM还没有挂载，无法获取*/
      this.$nextTick(()=>{
        this.tableHeight = this.$refs.date.offsetHeight - 36;
      });
    },
    created(){
      /*在页面初始化时调用获取实时高度函数*/
      this.getHeight();
      /*接收数据*/
      bus.$on("dyn",msg=>{
        this.tableData = msg;
      });
      /*接收案例编号*/
      bus.$on("caseNumber",msg=>{
        for(let i = 0;i < this.tableData.length;i++){
          this.tableData[i].caseNumber = msg;
        }
      });
    }
  }
</script>

<style scoped>
  .dialogDyn{
    width: 99%;
    height: 100%;
  }
  .el-pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/data/dialogDyn.vue